﻿import nav from "./components/nav";

nav();

if (document.querySelector(".js-animate")) {
  import("./components/animate").then(init => init.default());
}

if (document.querySelector(".js-notification")) {
  import("./components/notification").then(init => init.default());
}

if (document.querySelector(".js-locations-toggle")) {
  import("./components/locationsList").then(init => init.default());
}

if (document.querySelector(".js-tabs")) {
  import("./components/tabs").then(init => init.default());
}

if (document.querySelector(".js-accordion")) {
  import("./components/accordion").then(init => init.default());
}

if (document.querySelector(".js-carousel")) {
  import("./components/carousel").then(init => init.default());
}
if (document.querySelector(".js-grid-carousel")) {
  import("./components/gridCarousel").then(init => init.default());
}
if (document.querySelector(".js-resource-hero-carousel")) {
  import("./components/resourceHeroCarousel").then(init => init.default());
}

if (document.querySelector(".js-gallery")) {
  import("./components/gallery").then(init => init.default());
}

if (document.querySelector(".js-language-picker-list")) {
  import("./components/languagePicker").then(init => init.default());
}

if (document.querySelector(".js-marquee")) {
  import("./components/marquee").then(init => init.default());
}

if (document.querySelector(".js-add-wrapper")) {
  import("./components/addWrapper").then(init => init.default());
}

if (document.querySelector(".js-bursary-lookup")) {
  import("./components/bursaryLookup").then(init => init.default());
}

if (document.querySelector(".js-share")) {
  import("./components/share").then(init => init.default());
}

if (document.querySelector(".js-form-popover")) {
  import("./components/gatewayForm").then(init => init.default());
}

if (document.querySelector(".js-register-form-trigger")) {
  import("./components/registerForm").then(init => init.default());
}

if (document.querySelector(".js-search")) {
  import("./components/search");
}
if (document.querySelector(".js-search-hero-form")) {
  import("./components/searchHeroForm").then(init => init.default());
}
if (document.querySelector(".js-filters")) {
  import("./components/filters").then(init => init.default());
}

if (document.querySelector(".js-auto-populate-fields")) {
  import("./components/autoFieldPopulation").then(init => init.default());
}

if (document.querySelector(".js-scale-on-scroll")) {
  import("./components/scaleOnScroll").then(init => init.default());
}

if (document.querySelector(".js-schools-lookup")) {
  import("./components/schoolsLookup").then(init => init.default());
}

if (document.querySelector(".js-activity-school-lookup")) {
  import("./components/activitySchoolLookup").then(init => init.default());
}

if (document.querySelector(".js-search-launcher")) {
  import("./components/searchLauncher").then(init => init.default());
}

if (document.querySelector(".js-testimonials")) {
  import("./components/testimonials").then(init => init.default());
}

if (document.querySelector(".js-recorded-download")) {
  import("./components/recordedDownload").then(init => init.default());
}

if (document.querySelector(".js-gated-download")) {
  import("./components/gatedDownload").then((init) => init.default());
}

if (document.querySelector(".js-member-email-lookup")) {
  import("./components/memberEmailLookup").then(init => init.default());
}

if (document.querySelector(".js-tooltip")) {
  import("./components/tooltip").then(init => init.default());
}

if (document.querySelector(".js-inline-page-navigation")) {
  import("./components/inlinePageNavigation").then(init => init.default());
}

if (document.querySelector(".js-showcase")) {
  import("./components/showcaseGallery").then(init => init.default());
}

if (document.querySelector(".js-resource-order")) {
  import("./components/resourceOrderGrid").then(init => init.default());
}

if (document.querySelector(".embed-block.cognito")) {
  import("./components/areaPicker").then(init => init.default());
}
